import React, { useEffect } from "react"
import SButton from "components/Common/Button"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Row, Col, Spinner, Container, Card, CardBody } from "reactstrap"
import {
  getFabricTradingByIdAPI,
  putFabricTradingAPI,
} from "helpers/fabric_trading_company_resource"
import { toast } from "react-toastify"
import { useParams, useHistory } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import BackButton from "components/Common/BackButton"

const EditFabricTrading = () => {
  const history = useHistory()

  const { id } = useParams()
  const [isProcessing, setIsProcessing] = React.useState(false)
  const [field, setField] = React.useState(null)
  const [customValidation, setCustomValidation] = React.useState({
    errorName: {
      status: false,
      message: "会社名 必須項目です",
    },
    errorManager: {
      status: false,
      message: "担当者 必須項目です",
    },
    errorCode: {
      status: false,
      message: "電話番号 必須項目です",
    },
    errorPhone: {
      status: false,
      message: "生地商社コード 必須項目です",
    },
  })

  const onChange = e => {
    let { name, value, checked } = e.target
    if (name === "outOfStockDeliveries") {
      let _temp = [...field.outOfStockDeliveries]
      checked && _temp.push(value)
      !checked && _temp.splice(_temp.indexOf(value), 1)
      setField({ ...field, outOfStockDeliveries: _temp })
    } else {
      setField({ ...field, [name]: value })

      if (name === "name") {
        setCustomValidation({
          ...customValidation,
          errorName: {
            ...customValidation.errorName,
            status: false,
          },
        })
      }

      if (name === "phone") {
        setCustomValidation({
          ...customValidation,
          errorPhone: {
            ...customValidation.errorPhone,
            status: false,
          },
        })
      }

      if (name === "code") {
        setCustomValidation({
          ...customValidation,
          errorCode: {
            ...customValidation.errorCode,
            status: false,
          },
        })
      }
      if (name === "manager") {
        setCustomValidation({
          ...customValidation,
          errorManager: {
            ...customValidation.errorManager,
            status: false,
          },
        })
      }
    }
  }

  const resetData = () => {
    setIsProcessing(false)
    setField(null)
    history.push("/master/fabric-trading-company")
  }

  const updateNewFabricTrading = async () => {
    setIsProcessing(true)
    try {
      let error = 0
      let defaultError = { ...customValidation }

      if (field.name === 0 || !field.name) {
        defaultError = {
          ...defaultError,
          errorName: { ...defaultError.errorName, status: true },
        }

        error += 1
      }
      if (field.phone === "" || !field.phone) {
        defaultError = {
          ...defaultError,
          errorPhone: { ...defaultError.errorPhone, status: true },
        }

        error += 1
      }
      if (field.code === "" || !field.code) {
        defaultError = {
          ...defaultError,
          errorCode: { ...defaultError.errorCode, status: true },
        }

        error += 1
      }
      if (field.manager === "" || !field.manager) {
        defaultError = {
          ...defaultError,
          errorManager: { ...defaultError.errorManager, status: true },
        }

        error += 1
      }
      setCustomValidation(defaultError)

      if (error === 0) {
        await putFabricTradingAPI(field, id)
        resetData()
      }
      setIsProcessing(false)
    } catch (error) {
      setIsProcessing(false)
    }
  }

  const fetchDataById = async () => {
    try {
      let { data } = await getFabricTradingByIdAPI(id)
      setField(data)
    } catch (error) {
      console.log("error: ", error.response)
    }
  }

  useEffect(() => {
    if (id) {
      fetchDataById()
    }
  }, [id])

  return (
    <div className="page-content">
      <Breadcrumb title={"生地商社マスター"} breadcrumbList={[]} />
      <Container fluid>
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <p className="fw-bold">生地商社マスター詳細</p>
              </Col>
              <Col className="d-flex justify-content-end">
                <SButton
                  onClick={updateNewFabricTrading}
                  className="button"
                  disabled={isProcessing}
                >
                  {isProcessing ? <Spinner size="sm" color="light" /> : "保存"}
                </SButton>
                <BackButton className="ms-2 button" />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInputWithLabel
                  label={
                    <>
                      会社名<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="name"
                  onChange={onChange}
                  value={field?.name}
                />
                {customValidation.errorName.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorName.message}
                  </p>
                )}
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={
                    <>
                      担当者<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="manager"
                  onChange={onChange}
                  value={field?.manager}
                />
                {customValidation.errorManager.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorManager.message}
                  </p>
                )}
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={
                    <>
                      電話番号<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="texxt"
                  name="phone"
                  onChange={onChange}
                  value={field?.phone}
                />
                {customValidation.errorPhone.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorPhone.message}
                  </p>
                )}
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={
                    <>
                      生地商社コード<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="code"
                  onChange={onChange}
                  value={field?.code}
                />
                {customValidation.errorCode.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorCode.message}
                  </p>
                )}
              </Col>
              <p className="mt-3">発注情報</p>
              <Col md="12">
                <TextInputWithLabel
                  label={"メールアドレス（To)"}
                  placeholder={""}
                  type="email"
                  name="emailTo"
                  onChange={onChange}
                  value={field?.emailTo}
                />
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={"メールアドレス（CC)"}
                  placeholder={""}
                  type="email"
                  name="emailCc"
                  onChange={onChange}
                  value={field?.emailCc}
                />
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={"発注方式"}
                  placeholder={""}
                  type="text"
                  name="orderingMethod"
                  onChange={onChange}
                  value={field?.orderingMethod}
                />
              </Col>
              {field && (
                <div className="mt-3">
                  <label>品切れ配信</label>
                  <div className="d-flex justify-content-start align-items-center mt-2">
                    <div className="d-flex align-items-center">
                      <input
                        onChange={onChange}
                        name="outOfStockDeliveries"
                        value="WEB"
                        type="checkbox"
                        defaultChecked={
                          field?.outOfStockDeliveries.find(a => a == "WEB")
                            ? true
                            : false
                        }
                      />
                      <label className="ms-2 mb-0">WEB</label>
                    </div>
                    <div className="d-flex align-items-center ms-5">
                      <input
                        onChange={onChange}
                        name="outOfStockDeliveries"
                        value="MAIL"
                        type="checkbox"
                        defaultChecked={
                          field?.outOfStockDeliveries.find(a => a == "MAIL")
                            ? true
                            : false
                        }
                      />
                      <label className="ms-2 mb-0">MAIL</label>
                    </div>
                    <div className="d-flex align-items-center ms-5">
                      <input
                        onChange={onChange}
                        name="outOfStockDeliveries"
                        value="都度確認"
                        type="checkbox"
                        defaultChecked={
                          field?.outOfStockDeliveries.find(a => a == "都度確認")
                            ? true
                            : false
                        }
                      />
                      <label className="ms-2 mb-0">都度確認</label>
                    </div>
                  </div>
                </div>
              )}

              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={"確認URL"}
                  placeholder={""}
                  type="text"
                  name="confirmationUrl"
                  onChange={onChange}
                  value={field?.confirmationUrl}
                />
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={"ユーザーID"}
                  placeholder={""}
                  name="userId"
                  onChange={onChange}
                  value={field?.userId}
                />
              </Col>
              <Col md="12" className="mt-3">
                <TextInputWithLabel
                  label={"Pass"}
                  placeholder={""}
                  type="password"
                  name="password"
                  onChange={onChange}
                  value={field?.password}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default EditFabricTrading
